const AboutApi = [
    {
        image: "",
        heading: "Search best online professional",
        description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum minus sequi at? Qui, inventore quisquam.",
    },
    {
        image: "",
        heading: "Search best online professional",
        description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum minus sequi at? Qui, inventore quisquam.",
    },
    {
        image: "",
        heading: "Search best online professional",
        description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum minus sequi at? Qui, inventore quisquam.",
    }
]

export default AboutApi;